/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HotelEditGroupServiceCommissionPercentApiRequest } from '../../models/hotel-edit-group-service-commission-percent-api-request';

export interface ApiHotelManageEditGroupServiceCommissionPercentPost$Params {
      body: HotelEditGroupServiceCommissionPercentApiRequest
}

export function apiHotelManageEditGroupServiceCommissionPercentPost(http: HttpClient, rootUrl: string, params: ApiHotelManageEditGroupServiceCommissionPercentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelManageEditGroupServiceCommissionPercentPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelManageEditGroupServiceCommissionPercentPost.PATH = '/api/hotel/manage/edit/group/service-commission-percent';
